// import React from 'react';
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     IconButton,
//     Typography,
//     Grid,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Paper,
//     Box,
//     Divider,
// } from '@mui/material';
// import { MdCancel } from "react-icons/md";
// import "../../OperatorRegistration/Modal/TableDataViewModal.css";
// import documentImage from "../../../Assets/Emirates_ID_Card_For_UAE_Citizens_(New).png"

// const TableDataViewModal = ({ open, onClose, modalViewHeadingName, notModalTable }) => {
//     const purchaser = {
//         firstName: 'Mani',
//         lastName: 'Krish',
//         email: 'manikrish@gmail.com',
//         mobileNumber: '9823281781',
//         userType: 'Individual',
//         documentType: 'Emirates ID',
//         addressLine1: 'CL-720',
//         addressLine2: 'Afza, Ajman',
//         city: 'Al Ain',
//         state: 'Abu Dhabi',
//         country: 'United Arab Emirates',
//         zipcode: '20000',
//         schemes: [
//             {
//                 name: 'Scheme 1',
//                 purchaseValue: '$1000',
//                 goldValue: '13.8 g',
//                 purchaseDate: '15 Jan 2025',
//                 maturityDate: '15 Jan 2027',
//             },
//         ],
//     };
//     const TableHeadModalData = ["Scheme Name", "Purchase Value", "Gold Value", 'Purchase Date', "Maturity Date"]

//     const Documents = [documentImage, documentImage, documentImage]

//     return (
//         <Dialog
//             open={open}
//             onClose={onClose}
//             fullWidth
//             maxWidth="md"
//             className="custom-dialog"
//             sx={{
//                 "& .MuiPaper-root": {
//                     borderRadius: "14px",
//                 },
//             }}
//         >
//             <Box sx={{ position: 'relative' }}>
//                 {/* Dialog Header */}
//                 <Box className="dialog-heading">
//                     <IconButton
//                         aria-label="Close"
//                         onClick={onClose}
//                         sx={{
//                             position: 'absolute',
//                             top: 8,
//                             right: 8,
//                             color: 'text.secondary',
//                         }}
//                     >
//                         <MdCancel />
//                     </IconButton>
//                     <DialogTitle className="custom-dialog-title">
//                         <Typography className="custom-title-text" color="white">
//                             {modalViewHeadingName}
//                         </Typography>
//                     </DialogTitle>
//                 </Box>
//             </Box>

//             <DialogContent>
//                 <Box p={{ xs: 2, md: 1 }}>
//                     <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>
//                         {/* Aligning using flex and justifyContent */}

//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     First Name
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.firstName}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Last Name
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.lastName}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     User Type
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.userType}</Typography>
//                             </Box>
//                         </Grid>
//                     </Grid>
//                     <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>

//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Email
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.email}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Mobile Number
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.mobileNumber}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Document Type
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.documentType}</Typography>
//                             </Box>
//                         </Grid>
//                     </Grid>
//                     <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>

//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Address Line 1
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.addressLine1}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Address Line 2
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.addressLine2}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     City
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.city}</Typography>
//                             </Box>
//                         </Grid>
//                     </Grid>
//                     <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>

//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     State
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.state}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     country
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.country}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Zipcode
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.zipcode}</Typography>
//                             </Box>
//                         </Grid>
//                     </Grid>

//                     <Divider sx={{ mt: 3 }} />

//                     {/* Schemes Table */}
//                     {!notModalTable && (
//                         <>
//                             <Box mt={4}>
//                                 <Typography variant="body2" gutterBottom>
//                                     Schemes Purchased
//                                 </Typography>
//                                 <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
//                                     <Table sx={{ borderCollapse: 'collapse' }}>
//                                         <TableHead>
//                                             <TableRow sx={{ p: "16px 0" }}>
//                                                 {TableHeadModalData.map((data, index) => (

//                                                     <TableCell sx={{
//                                                         color: "#7A7A7A", border: "none", p: "10px 10px 0 0px", whiteSpace: 'nowrap',
//                                                         textOverflow: 'ellipsis',
//                                                     }}>
//                                                         <Typography variant='body1'> {data}</Typography></TableCell>
//                                                 ))}
//                                             </TableRow>
//                                         </TableHead>

//                                         <TableBody>
//                                             {purchaser.schemes.map((scheme, index) => (
//                                                 <TableRow key={index}>
//                                                     {Object.keys(scheme).map((key) => (
//                                                         <TableCell key={key} sx={{
//                                                             border: "none", p: "10px 10px 0 0px", whiteSpace: 'nowrap',
//                                                             textOverflow: 'ellipsis',
//                                                         }} >
//                                                             <Typography variant='subtitle2'>
//                                                                 {scheme[key]}
//                                                             </Typography>
//                                                         </TableCell>
//                                                     ))}
//                                                 </TableRow>
//                                             ))}
//                                         </TableBody>

//                                     </Table>
//                                 </TableContainer>
//                             </Box>
//                             <Divider sx={{ mt: 3 }} />

//                         </>
//                     )}

//                     <Grid xs={12} mt={1}>
//                         <Typography variant="body2">
//                             Documents
//                         </Typography>
//                         <Grid container spacing={2} mt={1}>
//                             {Documents.map((data, index) => (
//                                 <Grid item xs={12} md={4} key={index}>
//                                     <Box sx={{ p: 1, background: "white", boxShadow: 2, borderRadius: "5px" }}>
//                                         <Box
//                                             component="img"
//                                             src={data}
//                                             height="200px"
//                                             width="100%"
//                                             display="block"
//                                             margin="0" // Center the image within the grid cell
//                                         />
//                                     </Box>
//                                 </Grid>
//                             ))}
//                         </Grid>
//                     </Grid>

//                 </Box>
//             </DialogContent>
//         </Dialog >
//     );
// };

// export default TableDataViewModal;

import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Divider,
  Button,
  Stack,
} from "@mui/material";
import { MdCancel } from "react-icons/md";
import "../../../../Components/ModalCss/TableDataViewModal.css";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../../ReduxStore/actions";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { clearTableGetId } from "../../../../ReduxStore/Slices/TableId/TableIdGetSlice";
import { clearCustomerId } from "../../../../ReduxStore/Slices/Operator/customerSlice";

const PurchaseApprovalModalView = ({ open, onClose, modalViewHeadingName, IsShowRejectApproveButton }) => {
  const purchaser = {
    firstName: "Mani",
    lastName: "Krish",
    email: "manikrish@gmail.com",
    mobileNumber: "9823281781",
    userType: "Individual",
    documentType: "Emirates ID",
    addressLine1: "CL-720",
    addressLine2: "Afza, Ajman",
    city: "Al Ain",
    state: "Abu Dhabi",
    country: "United Arab Emirates",
    zipcode: "20000",
    schemes: [
      {
        name: "Scheme 1",
        purchaseValue: "$1000",
        goldValue: "13.8 g",
        purchaseDate: "15 Jan 2025",
        maturityDate: "15 Jan 2027",
      }
    ],
  };

  const TableHeadModalData = [
    "Scheme Name",
    "Purchase Value",
    "Gold Value",
    "Purchase Date",
    "Maturity Date",
  ];

  const [purchaserData, setPurchaserData] = useState({

  })

  const TableId = useSelector((state) => state.Table.TableId);
  console.log(TableId, "tableIddd")


  const { getPurchaseById } = useSelector((state) => state?.getPurchaseById);

  const dispatch = useDispatch()


  useEffect(() => {
    if (!open || !TableId) return; // Prevents unnecessary calls when modal is closed

    let isMounted = true; // Flag to check if the component is still mounted
    const fetchData = async () => {
      try {
        const data1 = {
          data: {},
          method: "get",
          apiName: `getPurchaseById/${TableId}`,
        };
        const responseData = await dispatch(actions.GETPURCHASEBYID(data1));

        if (isMounted) {
          setPurchaserData({
            name: `${responseData?.payload?.data?.customer?.first_name} ${responseData?.payload?.data?.customer?.last_name}` || "--",
            email: responseData?.payload?.data?.customer?.email || "--",
            customer_id: responseData?.payload?.data?.customer_id || "--",
            purchase_id: responseData?.payload?.data?.purchase_id || "--",
            plan_id: responseData?.payload?.data?.plan_id,
            valueOfPurchase: `$ ${responseData?.payload?.data?.value_of_purchase || "--"}`,
            purchaseStake: `${responseData?.payload?.data?.purchase_stake || "--"} grams`,
            maturity: `${responseData?.payload?.data?.maturity_in_months || "--"} Months`,
            lockIn: `${responseData?.payload?.data?.lock_in_months || "--"} Months`,
            reapBenifits: `${responseData?.payload?.data?.reap_percentage || "--"}% Every ${responseData?.payload?.data?.reap_months || "--"} Months`,
            purchaseDate: responseData?.payload?.data?.purchase_date
              ? format(new Date(responseData.payload.data.purchase_date), 'MMMM d, yyyy')
              : "--",
            stakeMaturity: responseData?.payload?.data?.stake_maturity
              ? format(new Date(responseData.payload.data.stake_maturity), 'MMMM d, yyyy')
              : "--",
            paymentType: `${responseData?.payload?.data?.payment_type || "--"}`,
          });

          // setSchemeCardData({
          //   title: responseData?.payload?.data?.title,
          //   valueOfPurchase: responseData?.payload?.data?.value_of_purchase,
          //   purchase: responseData?.payload?.data?.purchase_stake,
          //   maturity: responseData?.payload?.data?.maturity_in_months,
          //   lockIn: responseData?.payload?.data?.lock_in_months,
          //   reap_months: responseData?.payload?.data?.reap_months,
          //   benefit: responseData?.payload?.data?.reap_percentage,
          //   closingDate: responseData?.payload?.data?.closure_date
          //     ? format(new Date(responseData.payload.data.closure_date), 'MMMM d, yyyy')
          //     : "15/11/2025",
          //   firstButtonText: responseData?.payload?.data?.primary_button_text,
          //   secondButtonText: responseData?.payload?.data?.secondary_button_text,
          //   image_url: responseData?.payload?.data?.image_url,
          // });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    return () => {
      isMounted = false; // Prevents state updates if the modal is closed
    };
  }, [dispatch, open, TableId]);


  const { approvePurchase } = useSelector((state) => state?.approvePurchase);


  const purchaseApprove = async (id) => {

    console.log(id, "hiiiiiiiiiiiiiiiiiiiiii")

    const data1 = { data: {}, method: "put", apiName: `approvePurchase/${id}` };
    const approveResponse = await dispatch(actions.APPROVEPURCHASE(data1));

    console.log(approveResponse.payload.message, "approveResponse");

    if (approveResponse.payload.message === "Purchase approved successfully.") {

      toast.success("Approved Successfully.")
      setTimeout(() => onClose(), 1500)
      dispatch(clearTableGetId(null))
      dispatch(clearCustomerId(null))


    }

    // if (approveResponse.payload.message === "This plan is already approved.") {

    //   toast.error("This plan is already approved.")
    //   setTimeout(() => onClose(), 1500)
    // }


  }


  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      className="custom-dialog"
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "14px",
        },
      }}
    >
      <Box sx={{ position: "relative" }}>
        {/* Dialog Header */}
        <Box className="dialog-heading">
          <IconButton
            aria-label="Close"
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "text.secondary",
            }}
          >
            <MdCancel />
          </IconButton>
          <DialogTitle className="custom-dialog-title">
            <Typography className="custom-title-text" color="white">
              {modalViewHeadingName}
            </Typography>
          </DialogTitle>
        </Box>
      </Box>

      <DialogContent>
        <Box
        // p={{ xs: 2, md: 3 }}
        >
          <Grid container spacing={2}>
            {/* Flex Grid for User Info */}
            {[
              { label: "Customer Name", value: purchaserData.name },
              { label: "Customer Email", value: purchaserData.email },
              { label: "Customer ID", value: purchaserData.customer_id },
              { label: "Scheme ID", value: purchaserData.plan_id },
              { label: "Value Of Purchase", value: purchaserData.valueOfPurchase },
              { label: "Purchase Stake", value: purchaserData.purchaseStake },
              { label: "Maturity", value: purchaserData.maturity },
              { label: "Lock In", value: purchaserData.lockIn },
              { label: "Reap Benifits", value: purchaserData.reapBenifits },
              { label: "Purchase Date", value: purchaserData.purchaseDate },
              { label: "Stake Maturity", value: purchaserData.stakeMaturity },
              { label: "Payment Type", value: purchaserData.paymentType },
            ].map((field, index) => (
              <Grid item xs={12} sm={4} md={4} key={index} width="100%">
                {" "}
                {/* Each item takes up 4 columns on small screens */}
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="space-between"
                >
                  <Typography
                    variant="body1"
                    className="tabledataview-content-textheading"
                  >
                    {field.label}
                  </Typography>
                  <Typography variant="subtitle2">{field.value}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
          <Divider sx={{ mt: 3 }} />

          {/* Schemes Table */}
          {/* <Box mt={4}>
            <Typography variant="body2" gutterBottom>
              Schemes Purchased
            </Typography>
            <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
              <Table sx={{ borderCollapse: "collapse" }}>
                <TableHead>
                  <TableRow sx={{ p: "16px 0" }}>
                    {TableHeadModalData.map((data, index) => (
                      <TableCell
                        sx={{ color: "#7A7A7A", border: "none", p: "10px 0" }}
                      >
                        <Typography variant="body1"> {data}</Typography>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {purchaser.schemes.map((scheme, index) => (
                    <TableRow key={index}>
                      {Object.keys(scheme).map((key) => (
                        <TableCell
                          key={key}
                          sx={{ border: "none", p: "6px 0" }}
                        >
                          <Typography variant="subtitle2">
                            {scheme[key]}
                          </Typography>
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box> */}
          {/* <Divider sx={{ mt: 3 }} /> */}

          {IsShowRejectApproveButton && (
            <>
              <Grid mt={1} sx={{ display: "flex", justifyContent: "end" }}>
                <Stack spacing={2} direction="row">
                  {/* <Button
                    variant="contained"
                    // onClick={handleGoStakeNowPage}

                    sx={{
                      // backgroundColor: "#C38F51",
                      textTransform: "none",
                      color: "#F53E5C",
                      fontSize: "16px",
                      // padding: "0px 40px",
                      padding: { xs: "0px 20px", md: "0px 40px" },

                      minHeight: "40px",
                      borderRadius: "23px",
                      boxShadow: "none",
                      border: "1px solid #F53E5C",
                      background: "white 0% 0% no-repeat padding-box",
                      // "&:hover": {
                      //     backgroundColor: "#3B4056",
                      // },
                    }}
                  >
                    
                    Reject
                  </Button> */}
                  <Button
                    variant="outlined"
                    onClick={() => {
                      purchaseApprove(purchaserData.purchase_id);
                    }}
                    sx={{
                      // backgroundColor: "#FFAA17",
                      border: "1px solid #1FC45B",
                      textTransform: "none",
                      boxShadow: "none",
                      color: "white",
                      fontSize: "16px",
                      padding: { xs: "0px 20px", md: "0px 40px" },
                      minHeight: "40px",
                      borderRadius: "23px",
                      // font: "normal normal normal 16px / 25px Roboto",
                      letterSpacing: "0px",
                      color: "white",
                      background: "#1FC45B",
                      // "&:hover": {
                      //     backgroundColor: "#C38F51",
                      // },
                    }}
                  >
                    {/* {bannerDates?.[0]?.additional_data?.[0]?.secondary_button_text || "Secondary Button"} */}
                    Approve
                  </Button>
                </Stack>
              </Grid>
            </>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PurchaseApprovalModalView;
